<template>
  <div class="content">
    <Modal
      v-model="showModal"
      :title="titleTxt"
      @on-ok="confirm"
      @on-cancel="cancel"
      :loading="$root.$children[0].modalLoading"
      width="600"
      class="my-modal top"
    >
      <div class="form-wrap">
        <Form :model="formData" :rules="formRules" ref="formRef" :label-width="100">
          <FormItem label="考试分类" class="full" prop="name">
            <Input
              v-model="formData.name"
              placeholder="请输入分类"
              @on-blur="
                event => {
                  formData.name = event.target.value.trim();
                }
              "
              :maxlength="32"
              :show-word-limit="true"
              clearable
            />
          </FormItem>
          <FormItem label="排序" class="full" prop="orderNum" :rules="[$units.formRule.justIntSort()]">
            <Input
              v-model="formData.orderNum"
              placeholder="请输入正整数,排序越大越靠前"
              type="number"
              @on-blur="
                event => {
                  formData.orderNum = event.target.value.trim();
                }
              "
              clearable
            />
          </FormItem>
        </Form>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      showModal: false,
      formData: {
        id: '',
        name: '', //名称
        orderNum: '' //排序
      }, // 协议文件列表
      formRules: {
        name: [
          {
            required: true,
            message: '请输入',
            trigger: 'blur'
          }
        ]
        // orderNum: [{
        // 	required: true,
        // 	message: '请输入',
        // 	trigger: 'blur'
        // }],
      },
      titleTxt: '' // 标题
    };
  },
  created() {},
  methods: {
    open(item) {
      if (item.id) {
        this.formData.id = item.id;
        this.getDetail();
      } else {
        this.formData.id = '';
      }
      this.titleTxt = item.id ? '编辑' : '新增';
      this.showModal = true;
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.resetFields();
      });
    },
    // 详情
    getDetail() {
      this.$http({
        url: `/buz/testColumn/read/detail`,
        type: 'GET',
        data: {
          id: this.formData.id
        }
      }).then(res => {
        this.formData = res.data;
      });
    },
    confirm() {
      this.$units.notCloseModal(this);
      this.$refs['formRef']
        .validate(valid => {
          if (valid) {
            this.$http({
              url: this.formData.id ? '/buz/testColumn/edit' : `/buz/testColumn/add`,
              type: 'POST',
              data: this.formData,
              apiPermissionCode: ''
            }).then(res => {
              this.$Message.success(this.formData.id ? '修改成功' : '新增成功');
              this.showModal = false;
              this.$emit('reload');
            });
          }
        })
        .catch(e => {});
    },
    cancel() {}
  }
};
</script>
<style lang="scss" scoped>
// @import '../index.scss';
.form-wrap {
  margin-top: 10px;
  .ivu-form {
    display: flex;
    flex-wrap: wrap;
  }

  /deep/ .ivu-form-item-label {
    word-break: keep-all;
    line-height: 32px;
    padding: 0 12px 0 0;
  }

  /deep/ .ivu-form-item {
    width: 33.333333%;
    padding-right: 30px;
    vertical-align: top;
    margin: 0;
    display: flex;
    margin-bottom: 25px;

    &.less {
      width: 50%;
    }

    &.two {
      width: 66.666666%;
    }

    &.full {
      width: 100%;
    }

    &.four {
      width: 25%;
    }

    &.big-label {
      .ivu-form-item-label {
        white-space: nowrap;
        float: none;
      }

      .ivu-form-item-content {
        display: inline-block;
        margin-left: 0 !important;
      }
    }
  }

  /deep/ .ivu-form-item-content {
    width: 100%;
    line-height: 32px;
    margin-left: 0 !important;

    > div {
      width: 100%;
    }

    .ivu-input {
      width: 100%;
    }
  }

  .btn-upload {
    display: inline-block;
    width: 88px;
    height: 32px;
    background: #f5f8ff;
    border-radius: 2px;
    border: 1px solid #eaf2ff;
    cursor: pointer;
    font-size: 14px;
    color: #236dff;
    line-height: 32px;
    text-align: center;
  }

  /deep/.uploadBoxs {
    width: 145px;
    height: 94px;
  }

  /deep/.demo-upload-list {
    width: 145px;
    height: 94px;
  }

  /deep/.demo-upload-list {
    img {
      width: 145px;
      height: 94px;
    }
  }

  textarea {
    width: 100%;
    height: 120px;
    border: 1px solid #dcdee2;
    outline: none;
    padding: 10px;
    resize: none;
    border-radius: 4px;
  }
}

.form-wrap {
  &::v-deep {
    .ivu-form-item {
      .ivu-form-item-content {
        width: calc(100% - 100px) !important;
      }
    }
  }
}
</style>
